function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { motion, AnimatePresence } from 'framer-motion';
import withStyles from 'isomorphic-style-loader/withStyles';
import map from 'lodash/map';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import SidebarPersonsLoader from 'components/Loaders/SidebarPersonsLoader';
import Dots from 'svg/dots.svg';
import App from 'modules/App';
import Notifications from 'modules/Notifications';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './SidebarSharingRequestsList.pcss';
var _React_PureComponent;
class SidebarSharingRequestsList extends (_React_PureComponent = React.PureComponent) {
    async onOpenMenu(evt, id) {
        evt.preventDefault();
        await this.props.onCloseDropdown();
        this.props.onOpenDropdown(`${constants.APPROVED_SHARING_REQUEST_DROPDOWN_LIST}-${id}`);
    }
    onReauthorizeAccess(evt, sharingRequest) {
        evt.preventDefault();
        this.props.onSetBeingApprovedSharingRequestId(sharingRequest.sharingRequestId);
        this.props.onOpenModal(constants.APPROVE_DATA_SHARING_MODAL);
    }
    onRevokeAccess(evt, sharingRequest) {
        evt.preventDefault();
        this.props.onSetFormContext(constants.REVOKE_ACCESS_FORM, sharingRequest);
        this.props.onOpenModal(constants.REVOKE_ACCESS_MODAL);
    }
    renderMenu(sharingRequest) {
        const dropdownId = `${constants.APPROVED_SHARING_REQUEST_DROPDOWN_LIST}-${sharingRequest.sharingRequestId}`;
        if (this.props.openDropdownId !== dropdownId) {
            return null;
        }
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                width: 0
            },
            animate: {
                width: 'auto'
            },
            exit: {
                width: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "dropdownMenu__container dropdownMenu__container--oposite ml-3",
            children: /*#__PURE__*/ _jsxs("ul", {
                className: "dropdownMenu__actions",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "",
                            onClick: (evt)=>this.onReauthorizeAccess(evt, sharingRequest),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.reauthorizeAccess))
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "",
                            onClick: (evt)=>this.onRevokeAccess(evt, sharingRequest),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.revokeAccess))
                        })
                    })
                ]
            })
        });
    }
    renderMenuContainer(sharingRequest) {
        const { sharingRequestId } = sharingRequest;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('dropdownMenu', styles.sidebarSharingRequestsList__dots),
            children: [
                /*#__PURE__*/ _jsx(Link, {
                    to: "",
                    onClick: (evt)=>this.onOpenMenu(evt, sharingRequestId),
                    children: /*#__PURE__*/ _jsx(Dots, {
                        className: "dropdownMenu__icon"
                    })
                }),
                /*#__PURE__*/ _jsx(AnimatePresence, {
                    children: this.renderMenu(sharingRequest)
                })
            ]
        });
    }
    renderAvatar(sharingRequest) {
        const avatar = sharingRequest.hcp ? sharingRequest.hcp.avatar : sharingRequest.clinic.logo;
        const avatarName = sharingRequest.hcp ? [
            sharingRequest.hcp.firstName,
            sharingRequest.hcp.lastName
        ] : sharingRequest.clinic.name;
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: avatar,
            name: avatarName,
            className: styles.item__avatar,
            imgClassName: styles.item__avatar__img,
            initialsClassName: styles.item__avatar__initials
        });
    }
    renderSharingRequest(sharingRequest) {
        if (sharingRequest.sharingStatus !== 'Approved') {
            return null;
        }
        const hcpName = sharingRequest.hcp ? `${sharingRequest.hcp.firstName} ${sharingRequest.hcp.lastName}` : sharingRequest.clinic.name;
        const clinicName = sharingRequest.hcp ? sharingRequest.clinic.name : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.unassigned));
        return /*#__PURE__*/ _jsx("li", {
            className: cn(styles.item__sidebarList, styles.sidebar__hcpCellExtended),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto pr-2",
                        children: this.renderAvatar(sharingRequest)
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                "data-hj-suppress": true,
                                className: styles.item__name,
                                children: hcpName
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.subitem__name,
                                children: clinicName
                            })
                        ]
                    }),
                    this.renderMenuContainer(sharingRequest)
                ]
            })
        }, sharingRequest.sharingRequestId);
    }
    render() {
        if (this.props.isInProgress) {
            return /*#__PURE__*/ _jsx(SidebarPersonsLoader, {
                itemsNumber: 5
            });
        }
        return /*#__PURE__*/ _jsx("ul", {
            className: styles.items,
            children: map(this.props.sharingRequests, (sharingRequest)=>this.renderSharingRequest(sharingRequest))
        });
    }
}
_define_property(SidebarSharingRequestsList, "propTypes", {
    // Explicit props
    sharingRequests: PropTypes.arrayOf(shapes.sharingRequest),
    // Implicit props
    isInProgress: PropTypes.bool,
    openDropdownId: PropTypes.string,
    lastReceivedNotification: Notifications.shapes.notification,
    // Implicit actions
    onFetchSharingRequests: PropTypes.func,
    onSetBeingApprovedSharingRequestId: PropTypes.func,
    onOpenDropdown: PropTypes.func,
    onCloseDropdown: PropTypes.func,
    onOpenModal: PropTypes.func,
    onSetFormContext: PropTypes.func
});
const mapStateToProps = (state)=>({
        isInProgress: selectors.isFetchSharingRequestsInProgress(state),
        openDropdownId: App.selectors.dropdown(state),
        lastReceivedNotification: Notifications.selectors.lastReceivedNotification(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSetBeingApprovedSharingRequestId: (sharingRequestId)=>dispatch(actions.setBeingApprovedSharingRequestId(sharingRequestId)),
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown()),
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId)),
        onSetFormContext: (formName, contextData)=>dispatch(App.actions.setFormContext(formName, contextData))
    });
const ConnectedSidebarSharingRequestsList = connect(mapStateToProps, mapDispatchToProps)(SidebarSharingRequestsList);
export default withStyles(styles)(ConnectedSidebarSharingRequestsList);
